import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Namuna1Info = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [selectedYear, setSelectedYear] = useState('2023-2024');

    // Hardcoded Data for Jama (Income)
    const jamaAccounts = [
        { id: '101', name: 'कर व फी' },
        { id: '514', name: 'सामान्य पाणीपट्टी' },
        { id: '515', name: 'खास पाणीपट्टी' },
        { id: '518', name: 'घरगुती उपयाग व गुरे व्यतिरीक्त इतर कारणासाठी पुरविलेल्या पाण्याबद्दल फी' },
        { id: '110', name: 'किरकोळ जमा रक्कमा' },
        { id: '536', name: 'किरकोळ जमा रक्कमा' },
        { id: '107', name: 'पाणी पुरवठा (तळे)' },
        { id: '137', name: 'पाणी पुरवठा (अंशदान)' },
        { id: '586', name: 'पाणीपुरवठा विद्दुत बिलापोटी (50%) जि.प. कडून' },
        { id: '587', name: 'पाणी शुद्धीकरण' },
        { id: '588', name: 'नळ जोडणी व इतर पा.पु. अनामत' },
        { id: '589', name: 'पाणीपट्टी नोटीस फी' },
        { id: '590', name: 'पाणीपट्टी जप्ती फी' },
        { id: '142', name: 'कपात' },
        { id: '592', name: 'भविष्य निधीचे अंशदान' },
        { id: '593', name: 'इतर कपात' },
        { id: '143', name: 'इतर देणी' },
        { id: '595', name: 'इतर देणी पाणीपुरवठा' },
        { id: '112', name: 'कर्ज अनामत व आगाऊ रक्कमा' },
        { id: '591', name: 'अनामत रकमा' },
        { id: '111', name: 'कर्ज' },
        { id: '541', name: 'आगाऊ दिलेल्या रक्कमा' }
    ];

    // Hardcoded Data for Nave (Debit)
    const naveAccounts = [
        { id: '113', name: 'सामान्य कारभार' },
        { id: '545', name: 'कार्यालयाचा नैमित्तिक खर्च' },
        { id: '114', name: 'पाणिपुरवठा' },
        { id: '546', name: 'नविन पाणीपुरवठा' },
        { id: '547', name: 'तळ्याच्या दुरुस्त्या' },
        { id: '548', name: 'विहिरींच्या दुरुस्त्या' },
        { id: '549', name: 'नदीवरील घाट सुस्थितीत ठेवणे व बांधकाम' },
        { id: '112', name: 'कर्ज अनामत व आगाऊ रक्कमा' },
        { id: '591', name: 'अनामत रकमा' },
        { id: '142', name: 'कपात' },
        { id: '592', name: 'भविष्य निधीचे अंशदान' },
        { id: '593', name: 'इतर कपात' },
        { id: '143', name: 'इतर देणी' },
        { id: '595', name: 'इतर देणी पाणीपुरवठा' },
        { id: '111', name: 'कर्ज' },
        { id: '541', name: 'आगाऊ दिलेल्या रक्कमा' }
    ];

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
            {/* Header */}
            <div className="bg-blue-800 text-white p-3 px-6 mb-4 flex justify-between items-center rounded-t-lg">
                <h2 className="text-xl font-medium">नमुना १ माहिती भरणे सुविधा</h2>
                <button 
                    onClick={() => navigate('/panipuravtha/permanent-info')}
                    className="px-4 py-1 bg-white/20 text-white rounded hover:bg-white/30 transition text-sm font-medium"
                >
                    मागे जा
                </button>
            </div>

            <div className="bg-white shadow-md rounded-b-lg p-6 border border-t-0 border-blue-800">
                {/* Controls */}
                <div className="flex gap-4 items-center mb-6">
                    <label className="font-medium">आर्थिक वर्ष :</label>
                    <select 
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        className="p-2 border border-blue-300 rounded w-64 focus:outline-none focus:ring-1 focus:ring-blue-500"
                    >
                        <option value="2023-2024">2023-2024</option>
                        <option value="2024-2025">2024-2025</option>
                    </select>
                    <button className="px-6 py-2 bg-blue-800 text-white rounded hover:bg-blue-900">
                        दाखवा
                    </button>
                </div>

                {/* Main Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    
                    {/* JAMA Section */}
                    <div>
                        <div className="bg-blue-800 text-white p-2 px-4 rounded-t">
                            जमा
                        </div>
                        <div className="border border-blue-800 border-t-0 rounded-b overflow-hidden h-96 overflow-y-auto">
                            <table className="w-full text-left border-collapse">
                                <thead className="bg-blue-900 text-white text-sm">
                                    <tr>
                                        <th className="p-2 border-r border-blue-800 w-16 text-center">खाते क्र.</th>
                                        <th className="p-2 border-r border-blue-800">खाते नाव</th>
                                        <th className="p-2 w-32 text-center">रक्कम</th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm">
                                    {jamaAccounts.map((acc, index) => (
                                        <tr key={index} className={`border-b border-gray-200 ${['101','110','107','142','143','112','111'].includes(acc.id) ? 'bg-blue-600 text-white font-medium' : 'hover:bg-gray-50'}`}>
                                            <td className="p-2 border-r text-center">{acc.id}</td>
                                            <td className="p-2 border-r">{acc.name}</td>
                                            <td className="p-1 text-center">
                                                <input 
                                                    type="text" 
                                                    defaultValue="0"
                                                    className={`w-full p-1 border rounded text-right ${['101','110','107','142','143','112','111'].includes(acc.id) ? 'text-black' : ''}`}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* NAVE Section */}
                    <div>
                        <div className="bg-blue-800 text-white p-2 px-4 rounded-t">
                            नावे
                        </div>
                        <div className="border border-blue-800 border-t-0 rounded-b overflow-hidden h-96 overflow-y-auto">
                            <table className="w-full text-left border-collapse">
                                <thead className="bg-blue-900 text-white text-sm">
                                    <tr>
                                        <th className="p-2 border-r border-blue-800 w-16 text-center">खाते क्र.</th>
                                        <th className="p-2 border-r border-blue-800">खाते नाव</th>
                                        <th className="p-2 w-32 text-center">रक्कम</th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm">
                                    {naveAccounts.map((acc, index) => (
                                        <tr key={index} className={`border-b border-gray-200 ${['113','114','112','142','143','111'].includes(acc.id) ? 'bg-blue-600 text-white font-medium' : 'hover:bg-gray-50'}`}>
                                            <td className="p-2 border-r text-center">{acc.id}</td>
                                            <td className="p-2 border-r">{acc.name}</td>
                                            <td className="p-1 text-center">
                                                <input 
                                                    type="text" 
                                                    defaultValue="0"
                                                    className={`w-full p-1 border rounded text-right ${['113','114','112','142','143','111'].includes(acc.id) ? 'text-black' : ''}`}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

                {/* Footer Buttons */}
                <div className="flex justify-center gap-4 mt-8">
                    <button className="px-8 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-medium">
                        साठविणे
                    </button>
                    <button 
                        onClick={() => navigate('/panipuravtha/permanent-info')}
                        className="px-8 py-2 bg-red-600 text-white rounded hover:bg-red-700 font-medium"
                    >
                        रद्द करणे
                    </button>
                </div>

            </div>
        </div>
    );
};

export default Namuna1Info;
